import Typography from '@mui/material/Typography';
import { useQuery } from '@tanstack/react-query';
import { AssetQueryKey, assetApi } from '../api.js';
import { AssetTable } from '../components/AssetTable.js';
import { PageHeader, QueryView, Section } from '../components/common.js';
import { MyInventoryBanner } from '../components/InventoryConfirm.js';
import { useAssetT } from '../i18n/index.js';

/** The assets the signed-in user uses. */
export function MyAssetsPage() {
  const t = useAssetT();
  const mine = useQuery({ queryKey: AssetQueryKey.MyAssets, queryFn: assetApi.myAssets });
  return (
    <>
      <PageHeader title={t('myAssets.title')} />
      <MyInventoryBanner />
      <Section>
        <QueryView query={mine}>
          {(data) =>
            data.assets.length === 0 ? (
              <Typography color="text.secondary">{t('myAssets.empty')}</Typography>
            ) : (
              <AssetTable assets={data.assets} />
            )
          }
        </QueryView>
      </Section>
    </>
  );
}
